import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import _ from 'lodash';
import BRSpan from '../../General/BRSpan';

class ListMenuSeattle extends Component {
  constructor(props) {
    super(props)

    this._itemsRefs = [];
    this._subItemsRefs = [];
    this.iScroller = null;
    this._refsSetup = false;

    this.state = {
      elements: null,
      activeElementId: null,
      showMenu: false
    }
  }

  componentDidMount() {
    this.renderElements(0, 0);
    setTimeout(() => {
      this.setupRefs();
    }, 500);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.parentId !== prevProps.parentId) {
      this.setState({
        activeElementId: null,
        showMenu: false
      });
      this.renderElements(0, 0);
      setTimeout(() => {
        this.setupRefs();
      }, 500);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.parentId !== nextProps.parentId) {
      this.setState({
        showMenu: false
      });
      this.removeRefs();
    }

    return true;
  }

  setupRefs = () => {
    if (!this._refsSetup) {
      if (this._itemsRefs.length > 0) {
        for (let i = 0; i < this._itemsRefs.length; i++) {
          if (this._itemsRefs[i] && this._itemsRefs[i].el) {
            this._itemsRefs[i].el.addEventListener('tap', () => this.handleClick(i), { passive: true });
            if (this._itemsRefs[i].children && this._itemsRefs[i].children.length > 0) {
              for (let j = 0; j < this._itemsRefs[i].children.length; j++) {
                if (this._itemsRefs[i].children[j]) {
                  this._itemsRefs[i].children[j].addEventListener('tap', () => this.handleChildClick(i, j), { passive: true });
                }
              }
            }
          }
        }
      }
      this._refsSetup = true;
    }
  }

  removeRefs = () => {
    try {
      if (this._itemsRefs.length > 0) {
        for (let i = 0; i < this._itemsRefs.length; i++) {
          this._itemsRefs[i].el.removeEventListener('tap', () => this.handleClick(i), { passive: true });
          if (this._itemsRefs[i].children && this._itemsRefs[i].children.length > 0) {
            for (let j = 0; j < this._itemsRefs[i].children.length; j++) {
              this._itemsRefs[i].children[j].removeEventListener('tap', () => this.handleChildClick(i, j), { passive: true });
            }
          }
        }
      }
    } catch(e) {}
    this._refsSetup = false;
  }

  handleClick = (i) => {
    this.props.click(this.props.parentId, i);
    if (this.props.items[i].children && this.props.items[i].children.length > 0) {
      this.renderElements(i, 0);
    } else {
      this.renderElements(i, null);
    }
  }
  
  handleChildClick = (i, j) => {
    this.props.click(this.props.parentId, i, j);
    this.renderElements(i ,j);
  }

  renderElements = (activeElementId, activeSubElementId) => {
    let ulStyle = {
      WebkitPaddingStart: 0.0086625 * this.props.regionWidth,
      WebkitMarginBefore: 0,
      WebkitMarginAfter: 0,
      listStyle:"none",
      textAlign: "right",
      borderRight: `solid ${0.0028125 * this.props.regionWidth}px white`
    }
    let liStyle = {
      paddingTop: 0.0050625 * this.props.regionWidth,
      paddingBottom: 0.0050625 * this.props.regionWidth,
      paddingRight: 0.0068625 * this.props.regionWidth
    }
    let subUlStyle = {
      WebkitPaddingStart: 0.0225 * this.props.regionWidth,
      listStyle:"none",
      textAlign: "right"
    }

    let menuFontSize = 0.009984 * this.props.regionWidth + "px";
    let submenuFontSize = 0.0078 * this.props.regionWidth + "px";

    let itemsRaw = _.orderBy(this.props.items, "rank", "asc")
    let items = itemsRaw.map((item, i) => {
      this._itemsRefs[i] = { children: [], el: null }
      if (item.children && item.children.length > 0 && !item.children[0].folder_module) {
        let childrenSorted = _.orderBy(item.children, "rank", "asc");

        let subitems = childrenSorted.map((subitem, j) => {
          let background = null;
          if (activeElementId === i && activeSubElementId === j) {
            background = this.props.listSubMenuSelectedBackground;
          }
          return (
            <li className="noselect" key={j} ref={el => this._itemsRefs[i].children[j] = el} style={{ ...liStyle, fontSize: submenuFontSize, background: background, WebkitPaddingStart: 0.0181125 * this.props.regionWidth }}> <BRSpan className="noselect" preWrap str={subitem.name.toUpperCase()}/></li>
          );
        });

        let background = activeElementId === i ? this.props.listMenuSelectedBackground : null;
        let display = activeElementId === i ? "block" : "none";
        return (
          <div key={i}>
            <li style={{ ...liStyle, fontSize: menuFontSize, paddingRight:0 }}>
              <div className="noselect" style={{ paddingRight:0.0068625 * this.props.regionWidth, background: background, paddingTop: 0.0050625 * this.props.regionWidth, paddingBottom: 0.0050625 * this.props.regionWidth }} ref={el => this._itemsRefs[i].el = el}> <BRSpan className="noselect" preWrap str={item.name.toUpperCase()}/> </div>
            </li>
            <ul style={{ ...subUlStyle, display:display }}>
              {subitems}
            </ul>
          </div>
        );
      } else {
        let backgroundColor = activeElementId === i ? this.props.listMenuSelectedBackground : null;
        return (
          <li className="noselect" key={i} ref={el => this._itemsRefs[i] = { el: el, children:[] }} style={{ ...liStyle, fontSize: menuFontSize, background: backgroundColor }}> <BRSpan className="noselect" preWrap str={item.name.toUpperCase()}/></li>
        );
      }
    });

    let elements = (
      <ul style={{ ...ulStyle }}>
        {items}
      </ul>
    );

    this.setState({
      showMenu: true,
      elements: elements,
    });
  }

  render() {
    return (
      <div style={{ height: 0.2287125 * this.props.regionWidth, touchAction:"none" }}>
        <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
          options={{
            mouseWheel: true,
            scrollbars: false,
            scrollX: false,
            scrollY: true,
            probeType: 2,
            bounce: false,
            momentum: true,
            deceleration: 0.015,
            useTransition: true,
            disableTouch: false,
            disablePointer: false,
            disableMouse: false,
            tap: true
          }}
        >
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showMenu}>
            
            {
              this.state.showMenu ?
              this.state.elements
              :null
            }
          </div>
        </CSSTransitionGroup>
        </ReactIScroll>
      </div>
    );
  }
}

export default ListMenuSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/ListMenuSeattle.jsx